<template>
<v-card
  @click="viewProduct"
  class="product-card"
  flat
  :class="{
    'product-card--no-click': tiendaCerrada || esAgotado,
    'product-card--agotado': esAgotado
  }"
>
<div class="d-flex flex-no-wrap justify-space-between product-row">
  <div class="product-left" :class="{ 'full-width': hasNoImage }">
    <v-card-title
      class="text-h6 product-title"
      :class="{ 'centered-title': hasNoImage }"
    >{{ product.nombre }}</v-card-title>
    <v-card-subtitle v-if="product.descripcion" class="product-subtitle">
      {{ product.descripcion }}
    </v-card-subtitle>
    <div class="price-row">
      <template v-if="tieneDescuento">
        <span class="price-discount">$ {{ descuento }}</span>
        <del class="price-original">$ {{ precioBase }}</del>
      </template>
      <template v-else>
        <span class="price">$ {{ precioBase }}</span>
      </template>
      <v-chip
        v-if="currentCartCount > 0 && !esAgotado"
        small
        color="secondary"
        outlined
        class="qty-chip"
      >x{{ currentCartCount }}</v-chip>
      <v-chip
        v-if="!categoriaDisponible"
        small
        label
        class="status-chip status-chip--horario"
      >Fuera de horario</v-chip>
      <v-chip
        v-else-if="esAgotado"
        small
        label
        color="error"
        dark
        class="status-chip status-chip--agotado"
      >Agotado</v-chip>
    </div>
  </div>
  <div v-if="!hasNoImage" class="product-image-wrap ma-3">
    <v-avatar
      class="product-avatar"
      size="100"
      rounded
    >
      <v-img :src="product.detalle.srcImg" :lazy-src="product.detalle.srcImg" :alt="product.nombre" cover></v-img>
    </v-avatar>
    <div v-if="!esAgotado && product.esMasVendido" class="best-seller-badge">
      <v-icon x-small color="teal darken-1">mdi-star</v-icon>
      <span>Más vendido</span>
    </div>
  </div>
  <div v-else-if="product.esMasVendido && !esAgotado" class="best-seller-inline">
    <v-icon x-small color="teal">mdi-star</v-icon>
    <span>Más vendido</span>
  </div>
</div>
</v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import descuentoHelper from '@/helpers/descuentosHelper.js'
import { saveCatalogPosition } from '@/helpers/catalogScroll.js'
import { isProductoAgotado } from '@/helpers/productoAgotado.js'

export default {
  name: 'ProductMobileCard',
  props: {
    product: {
      type: Object
    },
    categoriaDisponible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('App', ['tiendaCerrada']),
    ...mapGetters('Carrito', ['getItems']),
    esAgotado () {
      return isProductoAgotado(this.product)
    },
    descuento () {
      return descuentoHelper.precioConDescuento(this.product)
    },
    precioBase () {
      return (this.product && this.product.precio) || (this.product && this.product.PrecioUnitario) || 0
    },
    tieneDescuento () {
      return Number(this.descuento) !== Number(this.precioBase)
    },
    hasNoImage () {
      return this.product && this.product.detalle && this.product.detalle.srcImg && this.product.detalle.srcImg.includes('noimage_Producto.png')
    },
    currentCartCount () {
      if (!this.product) return 0
      const matches = (this.getItems || []).filter(i => i.productId === this.product.id)
      if (!matches.length) return 0
      return matches.reduce((sum, it) => sum + (Number(it.cant) || 0), 0)
    }
  },
  methods: {
    viewProduct () {
      if (this.tiendaCerrada || this.esAgotado) return
      saveCatalogPosition(this.$route)
      const code = this.$clientCode()
      if (this.$route.params.mesaId) {
        this.$router.push({
          name: 'ProductoQR',
          params: {
            client: code,
            id: this.product.id,
            mesaId: this.$route.params.mesaId
          }
        })
        return
      }
      this.$router.push({
        name: 'Producto',
        params: {
          client: code,
          id: this.product.id
        }
      })
    }
  }
}
</script>
<style scoped>
.v-card__text, .v-card__title {
  word-break: normal;
}
.product-card {
  cursor: pointer;
  background: transparent !important;
  border-radius: 0 !important;
  padding: 12px 4px;
}
.product-card--no-click {
  cursor: default;
}
.product-card--agotado {
  opacity: 0.78;
}
.product-row {
  align-items: flex-start;
}
.product-left {
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 8px;
}
.product-title {
  width: 100%;
  overflow: visible;
  white-space: normal;
  padding: 0 !important;
  font-weight: 700 !important;
  line-height: 1.25 !important;
}
.product-subtitle {
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-top: 4px;
  padding: 0 !important;
}
.price-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}
.price,
.price-discount {
  font-weight: 700;
  font-size: 1rem;
}
.price-original {
  color: rgba(0, 0, 0, 0.45);
  font-size: 0.85rem;
}
.qty-chip {
  height: 22px !important;
  font-weight: 700;
}
.status-chip {
  height: 24px !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em !important;
}
.status-chip--horario {
  background: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.65) !important;
}
.status-chip--agotado {
  font-weight: 800 !important;
}
.full-width {
  flex: 1 1 100% !important;
}
.centered-title {
  text-align: left;
  justify-content: flex-start;
}
.product-image-wrap {
  position: relative;
  flex-shrink: 0;
  width: 100px;
  height: 100px;
}
.product-avatar {
  display: block;
}
.best-seller-badge {
  position: absolute;
  left: 4px;
  bottom: 4px;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: rgba(255, 255, 255, 0.92);
  color: #00695c;
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 1;
  padding: 3px 5px;
  border-radius: 999px;
  max-width: calc(100% - 8px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
.best-seller-inline {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #00897b;
  font-size: 0.7rem;
  font-weight: 600;
  align-self: flex-start;
  margin-top: 4px;
}
</style>
